import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import {
  contractorDropdownLabel,
  employeeDropdownLabel,
  formatDDMMYYYYbyYYYYMMDD,
} from "app/_helpers/helper";
import { getTrainingAssignersById } from "app/_services/ehs/ehsTrainingServices";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import ViewComments from "../IncidentManagement/ViewComments";
import {
  TRAINING_STATUS_VIEW,
  TRAINING_TYPE_VIEW,
  trainerTypeObj,
  trainerTypeView,
} from "./CONSTANTS";
import TrainingTimeline from "./TrainingTimeline";
import { staffType } from "../IncidentManagement/CONSTANTS";
import ViewCommentsComponent from "../IncidentManagement/ViewCommentsComponent";
import CompletionProof from "../CapaManagement/CompletionProof";
import { DDMMYYYYFormat } from "app/_helpers/dateHelper";
import toastr from "toastr";
function TrainingView({
  match: {
    params: { id },
  },
  history,
}) {
  const [tab, setTab] = useState(1);
  const [training, setTraining] = useState([]);

  useEffect(() => {
    getTrainingAssignersById(id).then((response) => {
      if (!response?.status) {
        history.push("/health-safety-and-environment/training-management");
        toastr.error(response?.message || "Something went Wrong");
        return;
      }

      if (!response?.data) return;

      setTraining(response?.data);
    });
  }, [id]);

  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "Training Management",
            path: "/health-safety-and-environment/training-management",
          },
          { name: "View" },
        ]}
      />

      <div className="healthSafetyEnvironmentWrapper mb-4">
        <div className="healthSafetyEnvironmentWrapper incidentMenu">
          <div className="hseMenuLinks card">
            <a
              onClick={() => setTab(1)}
              className={`pointer${tab === 1 ? " active" : ""}`}
              href
            >
              Timeline
            </a>

            <a
              onClick={() => setTab(2)}
              className={`pointer${tab === 2 ? " active" : ""}`}
              href
            >
              Training Details
            </a>
            {training?.incidentReviewsData?.length > 0 && (
              <a
                onClick={() => setTab(3)}
                className={`pointer${tab === 3 ? " active" : ""}`}
                href
              >
                Workflow Inputs
              </a>
            )}
          </div>
        </div>
      </div>

      {tab === 1 && <TrainingTimeline form={training} />}
      {tab === 2 && (
        <>
          <div className="card p-3 mt-4">
            <div className="simple-card-title">
              <h3 class="text-capitalize mb-0">Details</h3>
            </div>
            <div className="ehsFormWrapper">
              <h5>Person Details</h5>
              <Row>
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500">Type</h5>
                    <p>{staffType[training?.traineeType]}</p>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500">Name</h5>
                    <p>
                      {training?.traineeType === "employee"
                        ? `${employeeDropdownLabel(training?.traineeData)}`
                        : `${contractorDropdownLabel(training?.traineeData)}`}
                    </p>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500">Designation</h5>
                    <p>{training?.traineeData?.designation}</p>
                  </div>
                </Col>
              </Row>
              <h5>Batches Details</h5>
              <Row>
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500">Training ID</h5>
                    <p>{training?.batchData?.trainingId}</p>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500">Batch ID</h5>
                    <p>{training?.batchData?.batchId}</p>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500">Training Type</h5>
                    <p>{TRAINING_TYPE_VIEW[training?.trainingType]}</p>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500">Name of Center</h5>
                    <p>{training?.batchData?.centerName}</p>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500">Center Code</h5>
                    <p>{training?.batchData?.centerCode}</p>
                  </div>
                </Col>
                {/* <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500">Area Of Operation</h5>
                    <p>{training?.batchData?.area?.name}</p>
                  </div>
                </Col> */}
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500">Duration (Days)</h5>
                    <p>{training?.batchData?.duration}</p>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500 mb-1">Training Category (Skill Area)</h5>
                    <p>{training?.trainingCategoryData?.name}</p>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500 mb-1">Training Category (Skill Subarea)</h5>
                    <p>
                      {
                        training?.trainingCategoryData?.subCategory.find(
                          (d) => d.id === training?.trainingSubCategory
                        )?.name
                      }
                    </p>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500 mb-1">Date of commencement of training</h5>
                    <p>{formatDDMMYYYYbyYYYYMMDD(training?.batchData?.trainingDate)}</p>
                  </div>
                </Col>

                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500 mb-1">End Date Of Training</h5>
                    <p>{formatDDMMYYYYbyYYYYMMDD(training?.batchData?.endDate)}</p>
                  </div>
                </Col>
                <Col md={4} className="form-group viewbox">
                  <h5 className="w-500 mb-1"> Number Of Days</h5>
                  <p>{training?.batchData?.numberOfDays}</p>
                </Col>
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500">Training Hours</h5>
                    <p>{training?.batchData?.trainingHours}</p>
                  </div>
                </Col>
                <Col md={4} className="form-group viewbox">
                  <h5 className="w-500 mb-1">Trainer Type</h5>
                  <p>{trainerTypeView[training?.batchData?.trainerType] || ""}</p>
                </Col>
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500">Trainer Name</h5>
                    <p>
                      {training?.batchData?.trainerType
                        ? training?.batchData?.trainerType === trainerTypeObj.external
                          ? training?.batchData?.trainerName
                          : `${training?.batchData?.trainerData?.firstName} ${training?.batchData?.trainerData?.lastName}`
                        : ""}
                    </p>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500">Description of "Other" Training</h5>
                    <p>{training?.batchData?.descriptionOther}</p>
                  </div>
                </Col>
                <Col md={4} className="form-group viewbox">
                  <h5 className="w-500 mb-1">Session</h5>
                  <p>{training?.batchData?.session}</p>
                </Col>
                <Col md={4} className="form-group viewbox">
                  <h5 className="w-500 mb-1">Schedule</h5>
                  <p>{training?.batchData?.schedule}</p>
                </Col>
              </Row>
              <h5>Training Details</h5>
              <Row>
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500">Location</h5>
                    <p>{training?.ehsSite?.name}</p>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500 mb-1">Created Date</h5>
                    <p>{formatDDMMYYYYbyYYYYMMDD(training?.createdAt)}</p>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500 mb-1">Due Date</h5>
                    <p>{formatDDMMYYYYbyYYYYMMDD(training?.dueDate)}</p>
                  </div>
                </Col>
                {training?.trainingCompleteDate && (
                  <Col lg={4}>
                    <div className="form-group viewbox">
                      <h5 className="w-500 mb-1">Training Completion Date</h5>
                      <p>{DDMMYYYYFormat(training?.trainingCompleteDate)}</p>
                    </div>
                  </Col>
                )}
                {training?.feedbackTestFile && (
                  <Col lg={4}>
                    <div className="form-group viewbox">
                      <h5 className="w-500">Feedback/Test</h5>
                      <p>{<CompletionProof file={training?.feedbackTestFile} />}</p>
                    </div>
                  </Col>
                )}
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500 mb-1">Status</h5>
                    <p>{TRAINING_STATUS_VIEW[training?.trainingStatus]}</p>
                  </div>
                </Col>
                {training?.mmApproveDate && (
                  <Col lg={4}>
                    <div className="form-group viewbox">
                      <h5 className="w-500 mb-1">Approval Date</h5>
                      <p>{formatDDMMYYYYbyYYYYMMDD(training?.mmApproveDate)}</p>
                    </div>
                  </Col>
                )}
                {training?.certificateId && (
                  <Col lg={4}>
                    <div className="form-group viewbox">
                      <h5 className="w-500">Certificate No</h5>
                      <p>{training?.certificateId}</p>
                    </div>
                  </Col>
                )}
              </Row>
            </div>
          </div>
        </>
      )}
      {tab === 3 && (
        <ViewCommentsComponent comments={training?.incidentReviewsData || []} />
      )}

      <div className="mt-4 text-center">
        <span className="btn btn-secondary mx-2" onClick={() => history.goBack()}>
          Go Back
        </span>
      </div>
    </div>
  );
}

export default TrainingView;
